import { FormikProps, withFormik } from "formik";
import { string, object } from "yup";
import { Input } from "../shared/Input";
import { Button } from "../shared/Button";
import { Modal } from "../shared/Modal";
import { useEffect } from "react";

export interface IForgotPasswordProps {
  onSubmit: (values: any, actions: any) => void;
  toggleForm: () => void;
  incorrectCreds?: boolean;
  setIncorrectCreds?: (value: boolean) => void;
}

interface FormikValues {
  email: string;
}

function ForgotPassword(
  props: FormikProps<FormikValues> & IForgotPasswordProps
) {
  useEffect(() => {
    document.body.classList.add("body-no-scroll");
    return () => {
      document.body.classList.remove("body-no-scroll");
    };
  }, []);
  useEffect(() => {
    if (props?.setIncorrectCreds) {
      props?.setIncorrectCreds(false);
    }
  }, []);
  return (
    <Modal
      isOpen={true}
      setISOpen={props.toggleForm}
      title="Forgot Password"
      content={
        <form onSubmit={props.handleSubmit}>
          <div className="flex items-center justify-center bg-white min-h-0.5  p-0">
            <div className="bg-white rounded-lg w-full max-w-sm p-3">
              <p className="text-sm text-gray-600 p-0">
                Enter your email address to receive a one-time passcode (OTP) to
                reset your password.
              </p>
              {props.incorrectCreds && (
                <p className="text-xs text-red-600 mb-4 text-justify">
                  Email not exist. Please try again.
                </p>
              )}
              <div className="grid gap-2 mt-2">
                <Input
                  label="Email"
                  name="email"
                  values={props.values}
                  errors={props.errors}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  touches={props.touched}
                  placeholder="Enter your Email"
                  className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                />

                <Button
                  className="bg-[#00B207] hover:opacity-70 rounded-full text-white py-2 w-full mt-4 hover:scale-105 duration-300"
                  name={props.isSubmitting ? "Submitting ..." : "Submit"}
                  type="submit"
                  loading={props.isSubmitting}
                  disabled={props.isSubmitting}
                />
              </div>
            </div>
          </div>
        </form>
      }
      showBackButton={true}
      onBackButtonClick={props.toggleForm}
    />
  );
}

export default withFormik<IForgotPasswordProps, FormikValues>({
  validationSchema: object().shape({
    email: string().email("Invalid email format").required("Email is required"),
  }),
  mapPropsToValues: () => ({
    email: "",
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values, { setSubmitting });
  },
})(ForgotPassword);
